export const SERVICE_TYPE_APPOINTMENT = 'appointment';
export const SERVICE_TYPE_VOUCHER = 'voucher';
export const SERVICE_TYPE_MEMBERSHIP = 'membership';
export const SERVICE_TYPE_PRODUCT = 'product';
export const SERVICE_TYPE_COURSE = 'course';
